import type { MessageDeliveryStatus } from 'models';
import { Icon, Space, Text } from 'ui';
import { useChatMessageFooter } from './hooks';

type P = {
  deliveryStatus: MessageDeliveryStatus;
};

const ChatMessageFooter = ({ deliveryStatus }: P) => {
  const footerContent = useChatMessageFooter({ deliveryStatus });

  if (!footerContent) {
    return null;
  }

  return (
    <Space align="center" className="chat-message-footer" size="xxxs">
      <Icon color={footerContent.iconColor} icon={footerContent.iconName} size="extra-extra-small" />
      <Text size="small" type={footerContent.textType}>
        {footerContent.label}
      </Text>
    </Space>
  );
};

export default ChatMessageFooter;
